import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TuiDialogContext } from '@taiga-ui/core';
import { injectContext } from '@taiga-ui/polymorpheus';

@Component({
  selector: 'app-geocoder-dialog',
  templateUrl: './geocoder-dialog.component.html',
  styleUrls: ['./geocoder-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeocoderDialogComponent {
  private readonly context = injectContext<TuiDialogContext<string[] | undefined>>();

  textValue?: string;
  loading = false;

  addMapObjects() {
    this.loading = true;

    const splittedText = this.textValue?.split('\n');
    this.context.completeWith(splittedText);
  }
}
